








import { Component, Vue } from 'vue-property-decorator';
import MainWrapper from '@/components/common/main.vue';
import { ConstantsNS } from '@/store/modules/constants';
import Meta from '@/utils/decorator';

@Component({
  components: {
    MainWrapper,
  },
})
export default class E500Page extends Vue {
  @ConstantsNS.State list: any;

  get title() {
    return (this.$t(`${this.list.e500Title}`, this.$i18n.locale) as string).replace('<br/>', '');
  }

  get text() {
    return this.$t(`${this.list.e500Text}`, this.$i18n.locale);
  }

  @Meta
  getMetaInfo() {
    return {
      title: this.title,
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: this.text,
        },
      ],
      htmlAttrs: {
        lang: this.$i18n.locale,
        amp: true,
      },
    };
  }
}
